export enum AlarmPriority {
  OFFLINE = 'Offline',
  CRITICAL = 'Critical',
  WARNING = 'Warning',
  INFO = 'Info',
}
